var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlternateEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 0 960 960",
    width: "24px",
    fill: "#006B87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 880Q397 880 324 848.5Q251 817 197 763Q143 709 111.5 636Q80 563 80 480Q80 397 111.5 324Q143 251 197 197Q251 143 324 111.5Q397 80 480 80Q563 80 636 111.5Q709 143 763 197Q817 251 848.5 324Q880 397 880 480L880 538Q880 597 839.5 638.5Q799 680 740 680Q705 680 674 665Q643 650 622 622Q593 651 556.5 665.5Q520 680 480 680Q397 680 338.5 621.5Q280 563 280 480Q280 397 338.5 338.5Q397 280 480 280Q563 280 621.5 338.5Q680 397 680 480L680 538Q680 564 697 582Q714 600 740 600Q766 600 783 582Q800 564 800 538L800 480Q800 346 707 253Q614 160 480 160Q346 160 253 253Q160 346 160 480Q160 614 253 707Q346 800 480 800L680 800L680 880L480 880ZM480 600Q530 600 565 565Q600 530 600 480Q600 430 565 395Q530 360 480 360Q430 360 395 395Q360 430 360 480Q360 530 395 565Q430 600 480 600Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlternateEmail);
export default __webpack_public_path__ + "static/media/Icon_AlternateEmail.8a05fb4154a952bfc3ec71f5f4ffdae5.svg";
export { ForwardRef as ReactComponent };